import { useEffect, useState } from 'react'
import { RefreshCw } from 'lucide-react'
import { SW_UPDATE_EVENT, applyServiceWorkerUpdate, hasWaitingUpdate } from '@/lib/registerSw'

/** "New version available -- Reload": shown when a new service worker is waiting. */
export function UpdatePrompt() {
  const [show, setShow] = useState(hasWaitingUpdate())
  useEffect(() => {
    const on = () => setShow(true)
    window.addEventListener(SW_UPDATE_EVENT, on)
    return () => window.removeEventListener(SW_UPDATE_EVENT, on)
  }, [])
  if (!show) return null
  return (
    <div role="status" data-testid="update-prompt"
      className="fixed inset-x-0 bottom-0 z-[110] flex justify-center px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] print:hidden">
      <div className="flex items-center gap-3 rounded-lg border border-border bg-card px-4 py-2.5 text-sm text-foreground shadow-card-hover">
        <RefreshCw className="size-4 text-link" aria-hidden />
        <span>New version available</span>
        <button type="button" onClick={applyServiceWorkerUpdate} className="font-semibold text-link hover:underline">Reload</button>
        <button type="button" onClick={() => setShow(false)} className="text-muted-foreground hover:text-foreground">Later</button>
      </div>
    </div>
  )
}
